import * as ActionTypes from '../constants/ActionTypes';
import API from '../helpers/api';

export function getCrf(options) {
	return async dispatch => {

		dispatch({
			type: ActionTypes.GET_CRF_REQUEST,
			payload: {
				loading: true
			}
		});

		const response = await API.crf.getCrf(options);

		if (response.meta.code !== 200) {
			return dispatch({
				type: ActionTypes.GET_CRF_ERROR,
				payload: {
					meta: response.meta,
					loading: false
				}
			});
		}

		const crf_options = response.data.crf;
		const formatCrfOptions = [];
		if(crf_options.length){
			// eslint-disable-next-line array-callback-return
			crf_options.map((crf_option, index) => {
				formatCrfOptions.push({ key: crf_option._id, text: crf_option.name, value: crf_option._id });
			});
		}

		let crfObj = JSON.parse(localStorage.getItem('crf'));
		if(!crfObj) {
			crfObj = {crf_id: formatCrfOptions[0].value, crf_name: formatCrfOptions[0].text};
			localStorage.setItem('crf', JSON.stringify(crfObj));
		}

		dispatch({
			type: ActionTypes.GET_CRF_SUCCESS,
			payload: {
				crf: formatCrfOptions
			}
		});

		dispatch({
			type: ActionTypes.UPDATE_DRAWER_FIELD,
			payload: {
				crf_id: crfObj.crf_id
			}
		});
	};
}
